import { render, staticRenderFns } from "./UIPhone.vue?vue&type=template&id=fbaa41f6&"
import script from "./UIPhone.vue?vue&type=script&lang=js&"
export * from "./UIPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports